export var EUoMEnum;
(function (EUoMEnum) {
    EUoMEnum["MolarFlowRate"] = "molar_flow_rate";
    EUoMEnum["MassFlowRate"] = "mass_flow_rate";
    EUoMEnum["VolumetricFlowRate"] = "volumetric_flow_rate";
})(EUoMEnum || (EUoMEnum = {}));
//# sourceMappingURL=uom.enum.js.map